// src/app/features/auth/login/login.component.ts

import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { CommonModule, DOCUMENT } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService, AuthError } from '../../../core/services/auth/auth.service';
import { AuthSession } from '../../../core/models/auth/auth-session.model';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, HttpClientModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrls: []
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  submitted = false;
  errorMessage: string | null = null;
  loading = false;
  showPassword = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email:    ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    this.submitted = true;
    this.errorMessage = null;

    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    const { email, password } = this.loginForm.value;

    this.authService.login(email, password).subscribe({
      next: (_session: AuthSession) => {
        this.loading = false;
        this.router.navigate(['/home']);
      },
      error: (err: AuthError) => {
        this.loading = false;

        if (err?.code === 'new_password_required') {
          const details = (err.details ?? {}) as { session?: string };
          const session = details?.session;

          if (session) {
            this.authService.setPasswordChallenge({ email, session });
            this.router.navigate(['/complete-password']);
            return;
          }

          this.errorMessage = this.translate.instant('AUTH.ERROR_PASSWORD_CHALLENGE');
          return;
        }

        this.errorMessage = err.message || this.translate.instant('AUTH.ERROR_LOGIN');
      }
    });
  }



  // Método para navegar a la pantalla de recuperación
  goToForgotPassword(): void {
    this.router.navigate(['/forgot-password']);
  }

  goToRegister(): void {
    this.router.navigateByUrl('/register').catch(() => {
      this.document.defaultView?.location.assign('/register');
    });
  }
}
